module.exports = __webpack_public_path__ + "static/img/UTSG校区.a5239dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG校区.png
// module id = Qunw
// module chunks = 0